import { render, staticRenderFns } from "./SelectList.vue?vue&type=template&id=081cd011&"
import script from "./SelectList.vue?vue&type=script&lang=ts&"
export * from "./SelectList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports